import React, { memo, ReactNode } from 'react';
import { OpenAccountFooter } from '@components-member/shared/openAccountFooter/openAccountFooter';

interface IBeforeActionsContentProps {
  outerFooterChildren?: ReactNode;
  innerFooterChildren?: ReactNode;
  translatonKey?: 'tradingAccountsOpenAccountAgree' | 'tradingAccountsOpenAccountAgreeNew';
  agree: boolean;
  changeAgree: () => void;
}

export const BeforeActionsContent = memo(
  ({
    agree,
    changeAgree,
    translatonKey,
    innerFooterChildren,
    outerFooterChildren,
  }: IBeforeActionsContentProps): JSX.Element => {
    return (
      <>
        {outerFooterChildren}
        <OpenAccountFooter agree={agree} changeAgree={changeAgree} translatonKey={translatonKey}>
          {innerFooterChildren}
        </OpenAccountFooter>
      </>
    );
  },
);
